<footer>
  <a href="http://www.advanc-ed.org/eprove" target="_blank">
    <img src="assets/images/eprove-radiused-diagnostics.svg"/>
  </a>
  <a href="http://www.advanc-ed.org/eprove" target="_blank">
    <img src="assets/images/eprove-radiused-eleot.svg"/>
  </a>
  <a href="http://www.advanc-ed.org/eprove" target="_blank">
    <img src="assets/images/eprove-radiused-surveys.svg"/>
  </a>
  <a href="http://www.advanc-ed.org/eprove" target="_blank">
    <img src="assets/images/eprove-radiused-strategies.svg"/>
  </a>
  <a href="http://www.advanc-ed.org/eprove" target="_blank">
    <img src="assets/images/eprove-radiused-workspace.svg"/>
  </a>
  <a href="http://www.advanc-ed.org/eprove" target="_blank">
    <img src="assets/images/eprove-radiused-analytics.svg"/>
  </a>
</footer>
